import React from 'react';

const variantMap = {
  success:  'badge-success',
  active:   'badge-success',
  approved: 'badge-success',
  warning:  'badge-warning',
  pending:  'badge-warning',
  error:    'badge-error',
  failed:   'badge-error',
  rejected: 'badge-error',
  info:     'badge-info',
  gold:     'badge-gold',
};

export default function StatusBadge({ status, label }) {
  const key     = status?.toLowerCase() || 'info';
  const cls     = variantMap[key] || 'badge-info';
  const display = label || status;

  return <span className={cls}>{display}</span>;
}
